// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.page_statistics__8j2wK {
  background-color: #fff;
  padding: 43px 53px;
  border-radius: 8px;
}

.page_statistics-header__YLhaV {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.page_statistics-title-container__uaHU0 {
  display: flex;
  align-items: center;
  gap: 20px;
}

.page_statistics-header-btn__0Du2w {
  width: 42px !important;
  height: 42px !important;
  padding: 0 !important;
}

.page_statistics-title-container__uaHU0 h1 {
  width: 100% !important;
  font-weight: 700;
  font-size: 24px !important;
  line-height: 100%;
  border-bottom-color: #000 !important;
}

.page_statistics-header-actions__mhGtw {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.page_statistics-header-actions__mhGtw h4 {
  font-weight: 600;
  font-size: 24px;
  line-height: 30px;
  margin-left: 6px;
  color: var(--primary-color);
}

.page_statistics-date__PH44t {
  margin-top: 21px;
  display: flex;
  align-items: center;
  gap: 32px;
  color: var(--gray-text);
  margin-bottom: 34px;
}

.page_statistics-filters__hAJye {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
}

.page_statistics-filters-item__YqmwM {
  display: flex;
  gap: 24px;
  align-items: flex-end;
  flex-wrap: wrap;
}

.page_statistics-charts__tpp7m {
  display: flex;
  flex-direction: column;
  gap: 71px;
  margin-top: 44px;
}

.page_statistics-chart-category-title__uQX3m {
  margin-bottom: 29px;
  width: max-content;
  height: 35px;
  gap: 8px;
  border-radius: 8px;
  padding-top: 8px;
  padding-right: 16px;
  padding-bottom: 8px;
  padding-left: 16px;
  background-color: var(--soft-blue);
  color: #232c4a;
  font-weight: 700;
  font-size: 16px;
  line-height: 100%;
}

.page_statistics-chart-list__-YqQB {
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 42px;
}

.page_statistics-chart-item__w5Nhn {
  display: flex;
  flex-direction: column;
  gap: 24px;
  width: 50%;
}

.page_statistics-chart-item__w5Nhn h2 {
  font-weight: 400;
  font-size: 20px;
  line-height: 100%;
}

.page_questions-text-list__L0Us4 {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.page_questions-text-item__HD7tN {
  border: 1px solid #000000;
  padding: 16px 32px;
  border-radius: 8px;
  font-weight: 400;
  font-size: 16px;
  line-height: 100%;
}

.page_statistics-header-actions-container__rbtxC{
  display: flex;
  align-items: center;
  gap: 16px;
}
`, "",{"version":3,"sources":["webpack://./src/pages/surveys-stadistics/styles/page.module.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,qBAAqB;AAEvB;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,0BAA0B;EAC1B,iBAAiB;EACjB,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,QAAQ;EACR,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,kCAAkC;EAClC,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX","sourcesContent":[".statistics {\n  background-color: #fff;\n  padding: 43px 53px;\n  border-radius: 8px;\n}\n\n.statistics-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.statistics-title-container {\n  display: flex;\n  align-items: center;\n  gap: 20px;\n}\n\n.statistics-header-btn {\n  width: 42px !important;\n  height: 42px !important;\n  padding: 0 !important;\n\n}\n\n.statistics-title-container h1 {\n  width: 100% !important;\n  font-weight: 700;\n  font-size: 24px !important;\n  line-height: 100%;\n  border-bottom-color: #000 !important;\n}\n\n.statistics-header-actions {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.statistics-header-actions h4 {\n  font-weight: 600;\n  font-size: 24px;\n  line-height: 30px;\n  margin-left: 6px;\n  color: var(--primary-color);\n}\n\n.statistics-date {\n  margin-top: 21px;\n  display: flex;\n  align-items: center;\n  gap: 32px;\n  color: var(--gray-text);\n  margin-bottom: 34px;\n}\n\n.statistics-filters {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  flex-wrap: wrap;\n}\n\n.statistics-filters-item {\n  display: flex;\n  gap: 24px;\n  align-items: flex-end;\n  flex-wrap: wrap;\n}\n\n.statistics-charts {\n  display: flex;\n  flex-direction: column;\n  gap: 71px;\n  margin-top: 44px;\n}\n\n.statistics-chart-category-title {\n  margin-bottom: 29px;\n  width: max-content;\n  height: 35px;\n  gap: 8px;\n  border-radius: 8px;\n  padding-top: 8px;\n  padding-right: 16px;\n  padding-bottom: 8px;\n  padding-left: 16px;\n  background-color: var(--soft-blue);\n  color: #232c4a;\n  font-weight: 700;\n  font-size: 16px;\n  line-height: 100%;\n}\n\n.statistics-chart-list {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  gap: 42px;\n}\n\n.statistics-chart-item {\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n  width: 50%;\n}\n\n.statistics-chart-item h2 {\n  font-weight: 400;\n  font-size: 20px;\n  line-height: 100%;\n}\n\n.questions-text-list {\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n}\n\n.questions-text-item {\n  border: 1px solid #000000;\n  padding: 16px 32px;\n  border-radius: 8px;\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 100%;\n}\n\n.statistics-header-actions-container{\n  display: flex;\n  align-items: center;\n  gap: 16px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"statistics": `page_statistics__8j2wK`,
	"statistics-header": `page_statistics-header__YLhaV`,
	"statistics-title-container": `page_statistics-title-container__uaHU0`,
	"statistics-header-btn": `page_statistics-header-btn__0Du2w`,
	"statistics-header-actions": `page_statistics-header-actions__mhGtw`,
	"statistics-date": `page_statistics-date__PH44t`,
	"statistics-filters": `page_statistics-filters__hAJye`,
	"statistics-filters-item": `page_statistics-filters-item__YqmwM`,
	"statistics-charts": `page_statistics-charts__tpp7m`,
	"statistics-chart-category-title": `page_statistics-chart-category-title__uQX3m`,
	"statistics-chart-list": `page_statistics-chart-list__-YqQB`,
	"statistics-chart-item": `page_statistics-chart-item__w5Nhn`,
	"questions-text-list": `page_questions-text-list__L0Us4`,
	"questions-text-item": `page_questions-text-item__HD7tN`,
	"statistics-header-actions-container": `page_statistics-header-actions-container__rbtxC`
};
export default ___CSS_LOADER_EXPORT___;
